@if (template.show) {
    <div class="agpr-original-tweet">
        @if (template.originalPosterHandle) { <p class="agpr-original-tweet-handle">{{ '@' + template.originalPosterHandle }}</p> }
        <p class="agpr-original-tweet-text">{{ template.originalPostText }}</p>
    </div>
}